<template>
               
        <v-sheet rounded class="v-sheet--offset d-flex align-center justify-center" :color="sheetColor" elevation="5" :height="isMobile ? 60 : 80" :width="isMobile ? 70 : 80">
            <v-icon dark :x-large='!isMobile'>{{icon}}</v-icon> <span class="white--text ml-2 data-generic-sheet">{{clicks || 0}}</span>
        </v-sheet>
      
</template>

<script>
	
export default {
    name: 'ClickDataSheet',
    props: [

        'icon', 'sheetColor', 'clicks'
        
    ],
    
};
    
</script>

<style scoped>
    .text {

        font-size: 20px;
        font-weight: 700


    }

    .card {

        height: 50px;
        margin-bottom: 50px;

    }
   
</style>
